import React, { Component } from 'react';
import Stats2Table from './visualization/stats2-table';

export default class Stats2 extends Component{

    constructor(props){
        super(props);
    }

    componentDidMount(){
        if ((typeof google === 'undefined') || (typeof google.visualization === 'undefined')) {
            google.charts.load('current', {packages: ['corechart','table', 'bar']});
        }
    }

    render(){
        return (
            <div className="row">
                <h1>Table</h1>
                <Stats2Table google={google}/>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// src/components/stats-2.js